import React from 'react';
import Paper from '@material-ui/core/Paper';
import { MenuProps } from 'react-select';
import { OptionTypeBase } from 'react-select/src/types';

export const Menu = (props: MenuProps<OptionTypeBase, boolean>) => {
  return (
    <Paper className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
};
